export const eForm = {
    "eFormSet": {
        "eFormSet01": "Form Type",
        "eFormSet02": "Effective Date",
        "eFormSet03": "Form Org",
        "eFormSet04": "Form Name",
        "eFormSet05": "Form Id",
        "eFormSet06": "Form use Flow",
        "eFormSet07": "Memo",
        "eFormSet08": "Form-Create",
        "eFormSet09": "Form-Update",
    },
    "eForm": {
        "eForm01": "Form",
        "eForm02": "Form Type",
        "eForm03": "Form Id",
        "eForm04": "Fill In Time",
        "eForm05": "Fill Form Date",
        "eForm06": "Are you sure you want to Send Flow?",
        "eForm07": "Form Flow",
        "eForm08": "Form Fill-Send Flow",
        "eForm09": "Form Fill-Create",
        "eForm10": "Form Fill-Update",
    },
    "eFormFlow": {
        "eFormFlow01": "Form Type",
        "eFormFlow02": "Fill Id",
        "eFormFlow03": "Remaining Days",
        "eFormFlow04": "Are you sure you want to audit？",
        "eFormFlow05": "Form Audit-Update",
        "eFormFlow06": "Provide Opinion",
        "eFormFlow07": "Accept",
        "eFormFlow08": "Reject",
        "eFormFlow09": "Subflow Active",
        "eFormFlow10": "Opinion is required",
        "eFormFlow11": "Accept",
        "eFormFlow12": "Reject",
        "eFormFlow13": "Subflow",
        "eFormFlow14": "Flow Code",
        "eFormFlow15": "Sub Flow Code",
        "eFormFlow16": "Is SubFlow",
        "eFormFlow17": "No",
        "eFormFlow18": "Yes"
    }
}